// extracted by mini-css-extract-plugin
export default {"TechScrumLabel":"CooperateTabs_TechScrumLabel__jsZI-"};